module.exports = __webpack_public_path__ + "static/media/facebook-icon.0c700bf7.svg";